import React from 'react';
import {
  Formik,
  Field,
} from 'formik';

import {
  Flex,
} from 'web-styled';
import {
  Modal,
  Button,
  TextField,
} from 'web-components';

type Props = {
  isOpen: boolean;
  initialValues: any;
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const EditFolder = ({
  isOpen,
  initialValues,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title="Edit Folder Name"
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        isSubmitting,
      }) => (
        <Flex
          column
          as="form"
          width="100%"
          spacing={15}
          onSubmit={handleSubmit}
        >
          <Field
            autoFocus
            name="name"
            label="Enter name"
            component={TextField}
          />
          <Flex spacing={10} width="100%" justify="center">
            <Button
              ghost
              appearance="danger"
              spacing="large"
              onClick={onRequestClose}
            >
              Cancel
            </Button>
            <Button
              ghost
              type="submit"
              appearance="primary"
              spacing="large"
              isLoading={isSubmitting}
              isDisabled={isSubmitting}
            >
              Rename
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default EditFolder;
